// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const Account = __t.object("Account", {
  accountId: __t.u256(),
  delegatedKey: __t.option(__t.u256()),
  get destination() {
    return Destination;
  },
  get uncommittedValue() {
    return Value;
  },
  nonce: __t.u64(),
});
export type Account = __Infer<typeof Account>;

export const AppConfig = __t.object("AppConfig", {
  id: __t.u8(),
  tradingEnabled: __t.bool(),
});
export type AppConfig = __Infer<typeof AppConfig>;

// The tagged union or sum type for the algebraic type `AssetId`.
export const AssetId = __t.enum("AssetId", {
  Ada: __t.unit(),
  get NativeToken() {
    return NativeToken;
  },
});
export type AssetId = __Infer<typeof AssetId>;

export const AssetValue = __t.object("AssetValue", {
  get asset() {
    return AssetId;
  },
  value: __t.u64(),
});
export type AssetValue = __Infer<typeof AssetValue>;

export const BlockConfirmation = __t.object("BlockConfirmation", {
  blockNumber: __t.u64(),
  get refundTxs() {
    return __t.array(RefundTx);
  },
});
export type BlockConfirmation = __Infer<typeof BlockConfirmation>;

// The tagged union or sum type for the algebraic type `Datum`.
export const Datum = __t.enum("Datum", {
  Inline: __t.byteArray(),
  Hash: __t.u256(),
});
export type Datum = __Infer<typeof Datum>;

export const Deposit = __t.object("Deposit", {
  requestId: __t.u64(),
  blockNumber: __t.u64(),
  accountId: __t.u256(),
  delegatedKey: __t.option(__t.u256()),
  get destination() {
    return Destination;
  },
  get value() {
    return Value;
  },
  refundTx: __t.option(__t.byteArray()),
  absorbedInBlock: __t.u64(),
  rejectedInBlock: __t.u64(),
  failureReason: __t.option(__t.string()),
});
export type Deposit = __Infer<typeof Deposit>;

export const Destination = __t.object("Destination", {
  address: __t.string(),
  get datum() {
    return __t.option(Datum);
  },
});
export type Destination = __Infer<typeof Destination>;

// The tagged union or sum type for the algebraic type `Event`.
export const Event = __t.enum("Event", {
  get Init() {
    return GenesisSettings;
  },
  get DepositRequested() {
    return Deposit;
  },
  get DepositAbsorbed() {
    return RequestUpdate;
  },
  get DepositRejected() {
    return RequestUpdate;
  },
  get BlockConfirmed() {
    return BlockConfirmation;
  },
  get RequestFailed() {
    return RequestFailure;
  },
  get MarketCreated() {
    return MarketSettings;
  },
  get OrderCreated() {
    return NewOrder;
  },
  get OrderUpdated() {
    return UpdatedOrder;
  },
  get ValueAdded() {
    return ValueChange;
  },
});
export type Event = __Infer<typeof Event>;

export const EventLog = __t.object("EventLog", {
  id: __t.u64(),
  get payload() {
    return Event;
  },
});
export type EventLog = __Infer<typeof EventLog>;

export const GenesisSettings = __t.object("GenesisSettings", {
  adminPublicKeyHash: __t.u256(),
  feeAccountPublicKeyHash: __t.u256(),
  get feeEvacuationDestination() {
    return Destination;
  },
});
export type GenesisSettings = __Infer<typeof GenesisSettings>;

export const LatestBlock = __t.object("LatestBlock", {
  id: __t.u8(),
  blockNumber: __t.u64(),
});
export type LatestBlock = __Infer<typeof LatestBlock>;

export const LatestConfirmedBlock = __t.object("LatestConfirmedBlock", {
  id: __t.u8(),
  blockNumber: __t.u64(),
});
export type LatestConfirmedBlock = __Infer<typeof LatestConfirmedBlock>;

export const LedgerParameters = __t.object("LedgerParameters", {
  id: __t.u8(),
  adminPublicKeyHash: __t.u256(),
  feeAccountPublicKeyHash: __t.u256(),
  get feeEvacuationDestination() {
    return Destination;
  },
});
export type LedgerParameters = __Infer<typeof LedgerParameters>;

export const Market = __t.object("Market", {
  key: __t.string(),
  get tradingPair() {
    return TradingPair;
  },
  get takerFee() {
    return Ratio;
  },
  get makerFee() {
    return Ratio;
  },
});
export type Market = __Infer<typeof Market>;

export const MarketSettings = __t.object("MarketSettings", {
  get tradingPair() {
    return TradingPair;
  },
  get takerFee() {
    return Ratio;
  },
  get makerFee() {
    return Ratio;
  },
});
export type MarketSettings = __Infer<typeof MarketSettings>;

export const NativeToken = __t.object("NativeToken", {
  policyId: __t.u256(),
  assetName: __t.byteArray(),
});
export type NativeToken = __Infer<typeof NativeToken>;

export const NewOrder = __t.object("NewOrder", {
  id: __t.u128(),
  amount: __t.u64(),
  asOf: __t.u64(),
  get pair() {
    return TradingPair;
  },
  owner: __t.u256(),
  nonce: __t.u64(),
  get side() {
    return Side;
  },
  price: __t.u128(),
  get destination() {
    return __t.option(Destination);
  },
});
export type NewOrder = __Infer<typeof NewOrder>;

export const Order = __t.object("Order", {
  id: __t.u128(),
  owner: __t.u256(),
  get pair() {
    return TradingPair;
  },
  get side() {
    return Side;
  },
  price: __t.u128(),
  originalAmount: __t.u64(),
  remaining: __t.u64(),
  get status() {
    return OrderStatus;
  },
  created: __t.u64(),
  get destination() {
    return __t.option(Destination);
  },
  lastExecuted: __t.u64(),
});
export type Order = __Infer<typeof Order>;

// The tagged union or sum type for the algebraic type `OrderStatus`.
export const OrderStatus = __t.enum("OrderStatus", {
  New: __t.unit(),
  PartiallyFilled: __t.unit(),
  Filled: __t.unit(),
  Cancelled: __t.unit(),
});
export type OrderStatus = __Infer<typeof OrderStatus>;

export const OrderbookDepth = __t.object("OrderbookDepth", {
  key: __t.string(),
  pairKey: __t.string(),
  get pair() {
    return TradingPair;
  },
  price: __t.u128(),
  bidAmount: __t.u64(),
  askAmount: __t.u64(),
});
export type OrderbookDepth = __Infer<typeof OrderbookDepth>;

export const Ratio = __t.object("Ratio", {
  numerator: __t.u64(),
  denominator: __t.u64(),
});
export type Ratio = __Infer<typeof Ratio>;

export const RefundTx = __t.object("RefundTx", {
  requestId: __t.u64(),
  signedRefundTx: __t.byteArray(),
});
export type RefundTx = __Infer<typeof RefundTx>;

export const RequestFailure = __t.object("RequestFailure", {
  requestId: __t.u64(),
  message: __t.string(),
});
export type RequestFailure = __Infer<typeof RequestFailure>;

export const RequestUpdate = __t.object("RequestUpdate", {
  blockNumber: __t.u64(),
  requestId: __t.u64(),
});
export type RequestUpdate = __Infer<typeof RequestUpdate>;

// The tagged union or sum type for the algebraic type `Side`.
export const Side = __t.enum("Side", {
  Bid: __t.unit(),
  Ask: __t.unit(),
});
export type Side = __Infer<typeof Side>;

export const TradingPair = __t.object("TradingPair", {
  get base() {
    return AssetId;
  },
  get quote() {
    return AssetId;
  },
});
export type TradingPair = __Infer<typeof TradingPair>;

export const UpdatedOrder = __t.object("UpdatedOrder", {
  id: __t.u128(),
  remaining: __t.u64(),
  get status() {
    return OrderStatus;
  },
  asOf: __t.u64(),
  nonce: __t.u64(),
});
export type UpdatedOrder = __Infer<typeof UpdatedOrder>;

export const Value = __t.object("Value", {
  get assets() {
    return __t.array(AssetValue);
  },
});
export type Value = __Infer<typeof Value>;

export const ValueChange = __t.object("ValueChange", {
  account: __t.u256(),
  get value() {
    return Value;
  },
});
export type ValueChange = __Infer<typeof ValueChange>;

